import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { formatDateAndHour } from 'utils/global/date.utils';
import LabelBoolen from 'components/molecules/labeledStatus/LabeledBoolen';
import { REPAYMENTS_TYPE } from 'services/advance/types';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button } from 'components/atoms';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { PiDownload } from 'react-icons/pi';
import { handleDownloadFile } from 'utils/global/linkToUrl.utils';
import { getApplicationSettings } from 'store/state';
import { formatCurrency } from 'utils/global/currency.utils';

const RepaymentsTable = () => {
 const { values } = useFormikContext<any>();
 const { t } = useTranslation();

 const getRepaymentFile = (url: string): void => {
  handleDownloadFile(url);
 };



 return (
  <Table
   id={"RepaymentsTable"}
   data={{ nodes: values.repayments }}
   columns={[
    {
     label: t('input.label.date'),
     renderCell: (item: any) => (
      <TableItem>
       <TableItem.Text text={`${formatDateAndHour(item.repaymentDate)}`} />
      </TableItem>
     ),
     resize: true,
    },
    {
     label: t('input.label.amount'),
     renderCell: (item: any) => (
      <TableItem>
       <TableItem.Currency text={formatCurrency(item.amount)} />
      </TableItem>
     ),
     resize: true,
    },
    {
     label: t('input.label.repaymentSource'),
     renderCell: (item: any) => (
      <TableItem>
       <TableItem.Text text={item.repaymentSource.name} />
      </TableItem>
     ),
     resize: true,
    },
    {
     label: t('input.label.repaymentDocumentNumber'),
     renderCell: (item: any) => (
      <TableItem>
       <TableItem.Text text={`${item.repaymentDocument.number.value}`} />
      </TableItem>
     ),
     resize: true,
    },
    {
     label: t('input.label.repaymentDocumentFilename'),
     renderCell: (item: any) => (
      <TableItem>
       <Button
        type="button"
        isClear
        variant={BUTTON_VARIANT.black}
        onlyIcon
        onClick={() => getRepaymentFile(item.repaymentDocument.fileName)}
       >
        <Button.Icon icon={<PiDownload />} />
        <Button.Text text={t('button.download')} />
       </Button>
      </TableItem>
     ),
     resize: true,
    },
    // {
    //  label: t('input.label.isPaidFromNet'),
    //  renderCell: (item: any) => (
    //   <TableItem>
    //    <LabelBoolen
    //     status={
    //      item.isPaidFromNet ? REPAYMENTS_TYPE.true : REPAYMENTS_TYPE.false
    //     }
    //    />
    //   </TableItem>
    //  ),
    //  resize: true,
    // },
   ]}
  />
 );
};

export default RepaymentsTable;
